export class AccessibilityManager {
  private announceElement: HTMLDivElement | null = null;

  init(): void {
    // Create live region for screen readers
    this.announceElement = document.createElement('div');
    this.announceElement.setAttribute('role', 'status');
    this.announceElement.setAttribute('aria-live', 'polite');
    this.announceElement.setAttribute('aria-atomic', 'true');
    this.announceElement.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)';
    document.body.appendChild(this.announceElement);

    // Set ARIA attributes on canvas
    const canvas = document.querySelector('canvas');
    if (canvas) {
      canvas.setAttribute('role', 'application');
      canvas.setAttribute('aria-label', 'Хомяки против скама - игра');
    }
  }

  announce(message: string): void {
    if (this.announceElement) {
      this.announceElement.textContent = message;
    }
  }

  setCanvasLabel(label: string): void {
    const canvas = document.querySelector('canvas');
    if (canvas) {
      canvas.setAttribute('aria-label', label);
    }
  }

  destroy(): void {
    this.announceElement?.remove();
  }
}

export const a11y = new AccessibilityManager();
